"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgroundMixin = void 0;
Object.defineProperty(exports, "buttonTotalResetMixin", {
  enumerable: true,
  get: function get() {
    return _ButtonStyled.buttonTotalResetMixin;
  }
});
exports.colorMixin = void 0;
Object.defineProperty(exports, "flexContainerMixin", {
  enumerable: true,
  get: function get() {
    return _mixins.flexContainerMixin;
  }
});
Object.defineProperty(exports, "fontWeightMixin", {
  enumerable: true,
  get: function get() {
    return _mixins2.fontWeightMixin;
  }
});
Object.defineProperty(exports, "getMarginFromProps", {
  enumerable: true,
  get: function get() {
    return _mixins.getMarginFromProps;
  }
});
Object.defineProperty(exports, "getMarginPropValue", {
  enumerable: true,
  get: function get() {
    return _mixins.getMarginPropValue;
  }
});
Object.defineProperty(exports, "getPaddingFromProps", {
  enumerable: true,
  get: function get() {
    return _mixins.getPaddingFromProps;
  }
});
Object.defineProperty(exports, "getPaddingPropValue", {
  enumerable: true,
  get: function get() {
    return _mixins.getPaddingPropValue;
  }
});
exports.hTagMixin = exports.gluedMixin = void 0;
Object.defineProperty(exports, "hiddenButReaderAccessibleMixin", {
  enumerable: true,
  get: function get() {
    return _mixins2.hiddenButReaderAccessibleMixin;
  }
});
Object.defineProperty(exports, "listBareMixin", {
  enumerable: true,
  get: function get() {
    return _mixins3.listBareMixin;
  }
});
Object.defineProperty(exports, "marginMixin", {
  enumerable: true,
  get: function get() {
    return _mixins.marginMixin;
  }
});
Object.defineProperty(exports, "marginMixinPropTypes", {
  enumerable: true,
  get: function get() {
    return _mixins.marginMixinPropTypes;
  }
});
Object.defineProperty(exports, "noMarginLastChild", {
  enumerable: true,
  get: function get() {
    return _mixins.noMarginLastChild;
  }
});
Object.defineProperty(exports, "padMyChildrenMixin", {
  enumerable: true,
  get: function get() {
    return _mixins.padMyChildrenMixin;
  }
});
Object.defineProperty(exports, "paddingMixin", {
  enumerable: true,
  get: function get() {
    return _mixins.paddingMixin;
  }
});
Object.defineProperty(exports, "paddingMixinPropTypes", {
  enumerable: true,
  get: function get() {
    return _mixins.paddingMixinPropTypes;
  }
});
Object.defineProperty(exports, "separatorMixin", {
  enumerable: true,
  get: function get() {
    return _mixins3.separatorMixin;
  }
});
Object.defineProperty(exports, "textAlignMixin", {
  enumerable: true,
  get: function get() {
    return _mixins2.textAlignMixin;
  }
});
Object.defineProperty(exports, "truncateChildrenMixin", {
  enumerable: true,
  get: function get() {
    return _mixins2.truncateChildrenMixin;
  }
});
Object.defineProperty(exports, "truncateMixin", {
  enumerable: true,
  get: function get() {
    return _mixins2.truncateMixin;
  }
});
var _styledComponents = require("styled-components");
var _ButtonStyled = require("./Buttons/ButtonStyled");
var _mixins = require("./Containers/mixins");
var _mixins2 = require("./Typography/mixins");
var _helpers = require("./helpers");
var _mixins3 = require("./Lists/mixins");
// eslint-disable-next-line import/no-cycle

var backgroundMixin = function backgroundMixin() {
  var fallbackColorName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transparent";
  return (0, _styledComponents.css)(["background-color:", ";"], function (props) {
    return (0, _helpers.getColor)(props, "backgroundColor", fallbackColorName);
  });
};
exports.backgroundMixin = backgroundMixin;
var colorMixin = function colorMixin() {
  var fallbackColorName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "inherit";
  return (0, _styledComponents.css)(["color:", ";"], function (props) {
    return (0, _helpers.getColor)(props, "color", fallbackColorName);
  });
};
exports.colorMixin = colorMixin;
var hTagMixin = function hTagMixin(tag) {
  return (0, _styledComponents.css)(["font-size:", ";font-weight:", ";line-height:", ";"], function (props) {
    return props.theme.fontSizes[tag] || props.theme.fontSizes.headings;
  }, function (props) {
    return props.theme.fontWeights[tag] || props.theme.fontWeights.headings;
  }, function (props) {
    return props.theme.lineHeights[tag] || props.theme.lineHeights.headings;
  });
};
exports.hTagMixin = hTagMixin;
var gluedMixin = function gluedMixin() {
  return (0, _styledComponents.css)(["", ""], function (props) {
    return props.glued && (0, _styledComponents.css)(["", " ", " ", ""], props.glued === "left" && (0, _styledComponents.css)(["border-top-left-radius:0;border-bottom-left-radius:0;border-left:0;"]), props.glued === "right" && (0, _styledComponents.css)(["border-top-right-radius:0;border-bottom-right-radius:0;border-right:0;"]), props.glued === "horizontal" && (0, _styledComponents.css)(["border-radius:0;border-left:0;border-right:0;"]));
  });
};
exports.gluedMixin = gluedMixin;